"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _button = _interopRequireDefault(require("../button"));
var _camelCase = _interopRequireDefault(require("../poly/camelCase"));
var _styles2 = require("../utilities/styles");
const _excluded = ["classes", "color", "size", "children", "active"];
const DEFAULT_ICON_SIZE = '40px';
const useClasses = (0, _styles.makeStyles)(({
  palette,
  accessibility: {
    highContrast
  }
}) => ({
  root: {
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 'initial',
    height: ({
      size
    }) => !!size.height ? size.height : DEFAULT_ICON_SIZE,
    width: ({
      size
    }) => !!size.width ? size.width : DEFAULT_ICON_SIZE,
    fontSize: '1.2em',
    border: '2px solid transparent',
    [highContrast.mediaQuery('active')]: {
      '& * svg': {
        color: 'ButtonText'
      }
    },
    color: ({
      color
    }) => color
  },
  label: {
    height: '100%'
  },
  primary: {
    borderColor: palette.common.black,
    '&:hover': {
      borderColor: palette.primary.main
    }
  },
  primaryFocus: {
    borderColor: palette.primary.main
  },
  activePrimary: {
    borderColor: palette.primary.main
  },
  secondary: {
    color: palette.secondary.contrastText,
    borderColor: palette.secondary.border,
    backgroundColor: palette.secondary.main,
    '&:hover, &:focus': {
      color: palette.secondary.contrastText,
      backgroundColor: palette.secondary.border,
      borderColor: palette.secondary.border
    }
  },
  secondaryFocus: {
    color: palette.primary.contrastText,
    backgroundColor: palette.primary.main
  },
  activeSecondary: {
    backgroundColor: palette.primary.main,
    borderColor: palette.primary.main
  },
  text: {
    '&:hover': {
      borderColor: palette.border.primary,
      backgroundColor: palette.background.primary.main
    }
  },
  textFocus: {
    borderColor: palette.border.primary,
    backgroundColor: palette.background.primary.main
  },
  activeText: {
    borderColor: palette.border.primary,
    backgroundColor: palette.background.primary.main
  }
}), {
  classNamePrefix: 'TCUIIconButton'
});
const IconButton = _ref => {
  let {
      classes,
      color,
      size,
      children,
      active
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useClasses({
    color,
    size
  });
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, rest, {
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx.default)(_classes.root, _classes[color], {
        [_classes[(0, _camelCase.default)(['active', color])]]: active
      }),
      label: _classes.label,
      focusVisible: _classes[(0, _camelCase.default)([color, 'focus'])]
    }, classes)
  }), children);
};
IconButton.propTypes = {
  active: _propTypes.default.bool,
  classes: _propTypes.default.object,
  color: _propTypes.default.oneOf(['primary', 'secondary', 'text']),
  size: _propTypes.default.shape({
    height: _propTypes.default.string,
    width: _propTypes.default.string
  }),
  children: _propTypes.default.node.isRequired
};
IconButton.defaultProps = {
  active: false,
  classes: {},
  color: 'secondary',
  size: {
    height: DEFAULT_ICON_SIZE,
    width: DEFAULT_ICON_SIZE
  },
  children: null
};
var _default = exports.default = IconButton;